// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import YouTubePlayer from 'react-player/lib/players/YouTube'

// Internal Dependencies:
import Resources from './Resources'
import Posts from './Posts'
import Subscribe from 'components/Subscribe/Subscribe'

class StartHere extends React.Component {
	render() {
		return (
			<div>
				<div className="wide-section wide-section-home-a -edge -bg-off-white">
					<div className="c-grid">
						<div className="-column-4">
							<p>
								Are you looking for a deeper connection with God?
								<br />
								Are you looking for a place to come to and be challenged, encouraged and equipped for a more satisfying walk with Jesus?
								<br />
								Are you unsure where to start or what else to do as you continue your walk, if you are already on a journey with Him?
								<br />
								Are you simply curious to find out more?
								<br />
								If yes, you have come to the right place!
							</p>

							<p>
								Welcome to the New Zealand Pacific Union Conference (NZPUC) Discipleship Hub. Here you can access our newest resources, read blogs and watch vlogs that have been created to inspire you on your discipleship journey. It is our prayer that this hub will help you deepen your walk with Jesus. Let’s make intentional steps closer to our Saviour as we grow individually and collectively, joining in the gospel commission. Join many others, just like you, who pray for a DiscipleSHIFT in the NZPUC region.
							</p>

							<p>
								A great way to learn more about Discipleship and start your own journey is to read this blog – <a href="/blog/the-solution-discipleship/">What is Discipleship?</a>
							</p>
						</div>

						<div className="-column-3">

						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( StartHere )



// WEBPACK FOOTER //
// ./views/main/page/StartHere.jsx